import { Component, inject } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SiaJsonEditorComponent } from '@sia/code-editor';
import { SiaTranslatePipe } from '@sia/shared';

@Component({
  selector: 'sia-template-import-dialog',
  standalone: true,
  imports: [
    SiaJsonEditorComponent,
    MatDialogTitle,
    MatDialogActions,
    MatDialogClose,
    SiaTranslatePipe,
    MatIconButton,
    MatButton,
    MatIcon,
    MatDialogContent,
  ],
  templateUrl: './template-import-dialog.component.html',
  styleUrl: './template-import-dialog.component.scss',
})
export class SiaTemplateImportDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<SiaTemplateImportDialogComponent>>(MatDialogRef);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  import() {
    this.dialogRef.close(this.data);
  }
}
